import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Stack,
  Table,
  TableCell,
  TableRow,
  TableHead,
  TableBody,
  Chip,
  TextField,
  Button,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import GlobalDialog from "../../../../components/mui/Dialogue/GlobalDialog";
import { ViewButton } from "../../../../components/mui/Buttons/Buttons";
import Loader3D from "../../../../components/Loader/Loader3D";
import { getTotalsessions } from "../../../../redux/features/CRDslice";

const SubjectSession = ({ courseEnrollmentId }) => {
  const [open, setOpen] = useState(false);

  const { loading, sesssioncount } = useSelector((state) => state.crd);

  const dispatch = useDispatch();

  const headers = ["Subject", "Total Session"];

  useEffect(() => {
    if (open) {
      dispatch(getTotalsessions(courseEnrollmentId));
    }
  }, [open]);

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      color: theme.palette.common.black,
      fontSize: 13,
      border: "1px solid #ccc",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 13,
      border: "1px solid #ccc",
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  }));

  return (
    <GlobalDialog
      title="Subjects And Total Sessions"
      open={open}
      setOpen={setOpen}
      fullWidth
      loading={true}
      closeButton={true}
      maxWidth={"sm"}
      popupButton={
        <ViewButton size="small" action={() => setOpen(true)}>
          View
        </ViewButton>
      }
      content={
        <>
          {loading ? (
            <Loader3D />
          ) : (
            <Table
              aria-label="simple table"
              sx={{
                border: "1px solid #ccc",
                borderCollapse: "collapse",
                marginTop: 2,
              }}
            >
              <TableHead>
                <TableRow>
                  {headers.map((header, index) => (
                    <StyledTableCell key={index} align="center">
                      {header}
                    </StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {sesssioncount?.map((row) => (
                  <StyledTableRow key={row.subject_enrollment_id}>
                    <StyledTableCell align="center">
                      {row.subject_name}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {row.total_sessions}
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </>
      }
    />
  );
};

export default SubjectSession;
